import React, { useMemo, useCallback } from "react";
import styles from "./ticketLink.module.scss";
import { KoText } from "packages/typography";
import KoIcon from "@kwapio/icons";
import KoButton from "packages/button";

function TicketLink(props) {
  const { data, row, onCellClick, onExtraClick, colName } = props;

  const issueIcon = useMemo(() => {
    const activityTypes = row?.activityTypes;
    if (!Array.isArray(activityTypes) || activityTypes.length === 0) return null;

    const matched = activityTypes.find(
      (o) => o.value === row?.issueType
    );

    return matched?.icon || activityTypes[0]?.icon || null;
  }, [row?.activityTypes, row?.issueType]);

  const handleCellClick = useCallback(() => {
    onCellClick?.(row, colName);
  }, [onCellClick, row, colName]);

  const handleExtraClick = useCallback(() => {
    onExtraClick?.(row);
  }, [onExtraClick, row]);

  return (
    <div className={styles.wrapper}>
      <div className={styles.cell} onClick={handleCellClick}>
        {issueIcon && (
          <KoIcon
            className={styles.icon}
            name={issueIcon}
            width={14}
            height={14}
          />
        )}
        <KoText className={styles.text} text={data} />
      </div>

      {row?.subTask && (
        <KoButton
          onClick={handleExtraClick}
          className={styles.btn}
          iconBtn
          type="text"
          icon={
            <KoIcon
              className={styles.icon}
              name="TreeOutlined"
              width={14}
              height={14}
            />
          }
        />
      )}

      {row?.logs?.length > 0 && data && (
        <KoButton
          onClick={handleExtraClick}
          className={styles.btn}
          iconBtn
          type="text"
          icon={
            <KoIcon
              className={styles.icon}
              name="LogOutlined"
              width={12}
              height={12}
            />
          }
        />
      )}
    </div>
  );
}

export default React.memo(TicketLink);
